import * as React from 'react'

import styled from '@emotion/styled'

import { HelpOutlineIcon } from '@arcade/web/icons/react'

import { Flex } from '../layout/Flex'
import Header from './../Header/Header'

export type HelperTextProps = {
  children: React.ReactNode
  onClick: () => void
}

const ChameleonHeader = styled(Header)`
  color: unset;
`

const IconContainer = styled(Flex)`
  margin-right: ${({ theme }) => theme.spacing.xs};
`

const Container = styled.div`
  display: inline-flex;
  color: ${props => props.theme.colors.link};
  cursor: pointer;
  width: fit-content;

  :hover {
    color: ${props => props.theme.colors.primaryButtonHover};
  }

  ${props => props.theme.motion.standardTransition}

  :active {
    ${props => props.theme.motion.standardActiveState}
    color: ${props => props.theme.colors.primaryButtonActive};
  }
`

/**
 * @deprecated Use ArcadeHelperText instead
 */
export const HelperText = React.forwardRef<HTMLDivElement, HelperTextProps>(({ children, onClick }, ref) => (
  <Container ref={ref} onClick={onClick} role="button" aria-label="Open helper text">
    <IconContainer alignItems="center">
      <HelpOutlineIcon size={24} />
    </IconContainer>
    <ChameleonHeader variant="labelMedium" color="tooltip">
      {children}
    </ChameleonHeader>
  </Container>
))

export default HelperText
